/**
 * CustomerSyncStatus entity - tracks sync state per customer (commercialCode, locationCode).
 */

import type { EntitySchema } from '../types';

export type CustomerSyncStatusType =
  | 'not_synced'
  | 'synced'
  | 'stale'
  | 'syncing'
  | 'error';

export interface CustomerSyncStatus extends Record<string, unknown> {
  id: string;
  company_id: string;
  commercial_code: string;
  location_code: string;
  status: CustomerSyncStatusType;
  last_sync_at: string | null;
  sync_started_at: string | null;
  error_message: string | null;
  coi_count: number;
  created_at: string;
  updated_at: string;
}

export const CustomerSyncStatusSchema: EntitySchema<CustomerSyncStatus> = {
  tableName: 'customer_sync_status',
  columns: [
    { name: 'id', type: 'TEXT', primary: true },
    { name: 'company_id', type: 'TEXT', nullable: false },
    { name: 'commercial_code', type: 'TEXT', nullable: false },
    { name: 'location_code', type: 'TEXT', nullable: false, default: '' },
    { name: 'status', type: 'TEXT', nullable: false, default: 'not_synced' },
    { name: 'last_sync_at', type: 'TEXT', nullable: true },
    { name: 'sync_started_at', type: 'TEXT', nullable: true },
    { name: 'error_message', type: 'TEXT', nullable: true },
    { name: 'coi_count', type: 'INTEGER', nullable: false, default: 0 },
    { name: 'created_at', type: 'TEXT', nullable: false },
    { name: 'updated_at', type: 'TEXT', nullable: false },
  ],
  indexes: [
    {
      name: 'idx_sync_status_customer_key',
      columns: ['company_id', 'commercial_code', 'location_code'],
      unique: true,
    },
    { name: 'idx_sync_status_company', columns: ['company_id'] },
    { name: 'idx_sync_status_status', columns: ['status'] },
    {
      name: 'idx_sync_status_stale_check',
      columns: ['company_id', 'last_sync_at'],
      where: "status = 'synced'",
    },
  ],
};
